export default "__VITE_ASSET__CzibPw4A__"